import React, { Fragment, useRef, useCallback, useState  } from "react";
import { Link, withRouter, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import {
  AppBar,
  Toolbar,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  Hidden,
  Tooltip,
  Box,
} from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InfoIcon from "@mui/icons-material/Info";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import MessagePopperButton from "./MessagePopperButton";
// import Balance from "./Balance";
import NavigationDrawer from "../../../shared/components/NavigationDrawer";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Auth, Amplify } from 'aws-amplify';


// function confirmUserAuth() {
//
//     try {
//       console.log("attempting to grab user");
//       const user = Auth.currentAuthenticatedUser({
//           bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
//       });
//       console.log("user", user);
//       return user
//     } catch (error) {
//         console.log('error getting user auth', error);
//         return null
//     }
// }



const styles = (theme) => ({
  appBar: {
    boxShadow: theme.shadows[6],
    backgroundColor: theme.palette.common.white,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft: 0,
    },
  },
  appBarToolbar: {
    display: "flex",
    justifyContent: "space-between",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    [theme.breakpoints.up("md")]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    [theme.breakpoints.up("lg")]: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
  },
  accountAvatar: {
    backgroundColor: theme.palette.secondary.main,
    height: 24,
    width: 24,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(1.5),
      marginRight: theme.spacing(1.5),
    },
  },
  drawerPaper: {
    height: "100%vh",
    whiteSpace: "nowrap",
    border: 0,
    width: theme.spacing(7),
    overflowX: "hidden",
    marginTop: theme.spacing(11.85),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
    backgroundColor: theme.palette.common.black,
  },
  smBordered: {
    [theme.breakpoints.down("sm")]: {
      borderRadius: "50% !important",
    },
  },
  menuLink: {
    textDecoration: "none",
    color: theme.palette.text.primary,

  },
  iconListItem: {
    width: "auto",
    borderRadius: theme.shape.borderRadius,
    paddingTop: 11,
    paddingBottom: 11,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  textPrimary: {
    color: theme.palette.primary.main,
  },
  mobileItemSelected: {
    backgroundColor: `${theme.palette.primary.main} !important`,
  },
  brandText: {
    fontFamily: "'Baloo Bhaijaan', cursive",
    fontWeight: 400,
  },
  username: {
    paddingLeft: 0,
    paddingRight: theme.spacing(2),
  },
  justifyCenter: {
    justifyContent: "center",
  },
  permanentDrawerListItem: {
    justifyContent: "center",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
});

function NavBar(props) {

  const { selectedTab, messages, classes, openAddBalanceDialog, theme, cognitoUser, setCognitoUser} = props;

  // Will be use to make website more accessible by screen readers
  const links = useRef([]);
  console.log("cog",Object.keys(cognitoUser).length);
  if (Object.keys(cognitoUser).length === 0){
        Auth.currentAuthenticatedUser({
            bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        }).then(userData => {if (userData !== null) {setCognitoUser(userData)}}).catch(err=>{
            console.log("error",err)
            window.location.href ='/';
            // return (<Redirect to='/' />)
      });
  }

  // {
  //   link: "/c/subscription",
  //   name: "Subscription",
  //   onClick: closeMobileDrawer,
  //   icon: {
  //     desktop: (
  //       <AccountBalanceIcon
  //         className={
  //           selectedTab === "Subscription"
  //             ? classes.textPrimary
  //             : "text-white"
  //         }
  //         fontSize="small"
  //       />
  //     ),
  //     mobile: <AccountBalanceIcon className="text-white" />,
  //   },
  // },

  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isSideDrawerOpen, setIsSideDrawerOpen] = useState(false);
  const isWidthUpSm = useMediaQuery(theme.breakpoints.up("sm"));
  async function signOut() {
      try {
          await Auth.signOut();
          console.log("Signed out?");
          window.location.href ='/';
      } catch (error) {
          console.log('error signing out: ', error);
      }
  }

  async function docClick() {
    window.location.href =`${process.env.REACT_APP_PHYSIOLOGY_DOCS_PAGE}`;
  }
  const openMobileDrawer = useCallback(() => {
   setIsMobileOpen(true);
  }, [setIsMobileOpen]);

  const closeMobileDrawer = useCallback(() => {
   setIsMobileOpen(false);
  }, [setIsMobileOpen]);

  const openDrawer = useCallback(() => {
   setIsSideDrawerOpen(true);
  }, [setIsSideDrawerOpen]);

  const closeDrawer = useCallback(() => {
   setIsSideDrawerOpen(false);
  }, [setIsSideDrawerOpen]);

  const menuItems = [
    {
      link: "/c/dashboard",
      name: "Dashboard",
      onClick: closeMobileDrawer,
      icon: {
        desktop: (
          <DashboardIcon
            className={
              selectedTab === "Dashboard" ? classes.textPrimary : "text-white"
            }
            fontSize="small"
          />
        ),
        mobile: <DashboardIcon className="text-white" />,
      },
    },

    {
      name: "Documentation",
      link:"/",
      onClick: docClick,
      icon: {
        desktop: (
          <InfoIcon
            className={
              selectedTab === "Info"
                ? classes.textPrimary
                : "text-white"
            }
            fontSize="small"
          />
        ),
        mobile: <AccountBalanceIcon className="text-white" />,
      },
    },
    {
      link: "/",
      name: "Logout",
      onClick: signOut,
      icon: {
        desktop: (
          <PowerSettingsNewIcon className="text-white" fontSize="small" />
        ),
        mobile: <PowerSettingsNewIcon className="text-white" />,
      },
    },
  ];
  // if (Object.keys(cognitoUser).length === 0){
  // if (cognitoUser == null){
  //   return (<Redirect to='/' />)
  // }
  // console.log("cog user",cognitoUser);
  // <Box>
  // {Object.keys(cognitoUser).length === 0 ? (<Typography
  //   className={classes.username}
  //   display="inline"
  //   color="primary"
  // >
  //   Not Logged In
  // </Typography>):(<Typography
  //   className={classes.username}
  //   display="inline"
  //   color="primary"
  // >
  //   {cognitoUser.attributes.email}
  // </Typography>)}
  //
  // </Box>
  return (
    <Fragment>
      <AppBar position="sticky" className={classes.appBar}>
        <Toolbar className={classes.appBarToolbar}  style={{marginBottom: 15+'px'}}>
          <Box display="flex" alignItems="center">
            <Hidden smDown>
              <img src="/images/logo.webp" alt="Presage Technologies" style={{marginTop: 15 + 'px'}}/>
            </Hidden>
          </Box>
          <Box>
          {Object.keys(cognitoUser).length === 0 ? (<Typography
            className={classes.username}
            display="inline"
            color="primary"
          >
            Not Logged In
          </Typography>):(<Typography
            className={classes.username}
            display="inline"
            color="primary"
          >
            {cognitoUser.attributes.email}
          </Typography>)}

          </Box>
        </Toolbar>
      </AppBar>
      <Hidden smDown>
        <Drawer //  both drawers can be combined into one for performance
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          open={false}
        >
          <List>
            {menuItems.map((element, index) => (
              <Link
                to={element.link}
                className={classes.menuLink}
                onClick={element.onClick}
                key={index}
                ref={(node) => {
                  links.current[index] = node;
                }}
              >
                <Tooltip
                  title={element.name}
                  placement="right"
                  key={element.name}
                >
                  <ListItem
                    selected={selectedTab === element.name}
                    button
                    divider={index !== menuItems.length - 1}
                    className={classes.permanentDrawerListItem}
                    onClick={() => {
                      links.current[index].click();
                    }}
                    aria-label={
                      element.name === "Logout"
                        ? "Logout"
                        : `Go to ${element.name}`
                    }
                  >
                    <ListItemIcon className={classes.justifyCenter}>
                      {element.icon.desktop}
                    </ListItemIcon>
                  </ListItem>
                </Tooltip>
              </Link>
            ))}
          </List>
        </Drawer>
      </Hidden>
      <NavigationDrawer
        menuItems={menuItems.map((element) => ({
          link: element.link,
          name: element.name,
          icon: element.icon.mobile,
          onClick: element.onClick,
        }))}
        anchor="left"
        open={isMobileOpen}
        selectedItem={selectedTab}
        onClose={closeMobileDrawer}
      />
    </Fragment>
  );
}

NavBar.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.object).isRequired,
  classes: PropTypes.object.isRequired,
  cognitoUser: PropTypes.object.isRequired,
  setCognitoUser: PropTypes.func.isRequired,
  openAddBalanceDialog: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(NavBar);
